export const recursiveDomSelector = (timer = 200) => (nbTry = 4) => (source) => (selector) => {
  return new Promise((resolve, reject) => {
    if (nbTry === 0) {
      reject('try to get selector to many times');
    }
    setTimeout(() => {
      const target = source.querySelector(selector);
      if (target) {
        resolve(target);
      }
      else {
        resolve(recursiveDomSelector(timer)(nbTry - 1)(source)(selector));
      }
    }, timer);
  });
};
//# sourceMappingURL=recursive-dom-selector.js.map
